export default "__VITE_ASSET__C$jJjiPr__"